var map = {
	"./Alien_symbol_0.png": 43147,
	"./Alien_symbol_1.png": 99637,
	"./Alien_symbol_2.png": 78105,
	"./Alien_symbol_3.png": 71856,
	"./Alien_symbol_4.png": 84079,
	"./Alien_symbol_5.png": 45062,
	"./Alien_symbol_6.png": 48650,
	"./Alien_symbol_7.png": 93236,
	"./Alien_symbol_8.png": 88531,
	"./Alien_symbol_9.png": 49674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 92654;